import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { getFullRawTheme, getDecodedTheme } from '@/customizer/utils/theme';

interface ContextProps {
	rawTheme: object;
	setRawTheme: Dispatch<SetStateAction<object>>;
	fullRawTheme: object;
	setFullRawTheme: Dispatch<SetStateAction<object>>;
	theme: object;
	setTheme: Dispatch<SetStateAction<object>>;
}

export const ThemeContext = React.createContext<ContextProps>({
	rawTheme: {},
	setRawTheme: () => {},
	fullRawTheme: {},
	setFullRawTheme: () => {},
	theme: {},
	setTheme: () => {},
});

const ThemeProvider = ({
	initialTheme,
	decodedTheme,
	blocksThemeControls,
	templatesThemeControls,
	preview,
	children,
}) => {
	const [rawTheme, setRawTheme] = useState(initialTheme);
	const [fullRawTheme, setFullRawTheme] = useState({});
	const [theme, setTheme] = useState(decodedTheme);

	const defaultContext = {
		rawTheme,
		setRawTheme,
		fullRawTheme,
		setFullRawTheme,
		theme,
		setTheme,
	};

	// Get new fullRawTheme + decodedTheme everytime rawTheme changed - only if on preview mode
	useEffect(() => {
		if (!preview) return;

		// Get full raw theme
		const fullTheme = getFullRawTheme(
			rawTheme,
			blocksThemeControls,
			templatesThemeControls
		);

		// Get decoded theme from fullRawTheme
		const decodedTheme = getDecodedTheme(
			rawTheme,
			blocksThemeControls,
			templatesThemeControls
		);

		// console.log(':::Decoded Theme:::', decodedTheme);

		// Set fullRawTheme with the full rawTheme (with default values, origin of the inheritance etc)
		setFullRawTheme(fullTheme);

		// Set theme with the decoded fullRawTheme
		setTheme(decodedTheme);
	}, [rawTheme]);

	useEffect(() => {
		if (preview) return;

		// console.log(':::Decoded Theme:::', decodedTheme);

		setTheme(decodedTheme);
	}, [decodedTheme]);

	return (
		<ThemeContext.Provider value={defaultContext}>
			{children}
		</ThemeContext.Provider>
	);
};

export default ThemeProvider;
